import { selector } from 'recoil'
import { shopIdAtom, shopListAtom, shopInfoAtom, brandInfoAtom } from './index'
import { ERROR_SHOP } from '@/common/constants'
import { getLoginShopid } from '@RootCommon/utils'

export const currentShopSelector = selector({
  key: 'currentShopSelector',
  get: ({ get }) => {
    const shopList = get(shopListAtom)
    const shopId = get(shopIdAtom)
    const currentShop = shopList.find(item => item.shopId === shopId)
    return currentShop || ERROR_SHOP
  },
})

export const currentShopIdSelector = selector({
  key: 'currentShopIdSelector',
  get: ({ get }) => {
    const shopInfo = get(shopInfoAtom)
    if (shopInfo?.shopId === undefined) return getLoginShopid()
    const { shopId } = shopInfo || ERROR_SHOP
    return shopId
  },
})

export const currentBrandIdSelector = selector({
  key: 'currentBrandIdSelector',
  get: ({ get }) => {
    const brandInfo = get(brandInfoAtom)
    if (brandInfo?.brandId === undefined) return
    const { brandId } = brandInfo
    return brandId
  },
})
